/*
  Lumara Scroll Reveal V3
  Archivo final en Shopify: assets/lumara-scroll-reveal.js
  Home: revela secciones desde la segunda.
  Producto: revela contenedores inferiores, excluyendo el contenedor principal de informacion de producto.
*/
(function () {
  'use strict';

  var CONFIG = {
    homeExcludeFirstSections: 1,
    readyClass: 'lumara-reveal-ready',
    visibleClass: 'lumara-reveal-visible',
    observedClass: 'lumara-reveal-observed',
    threshold: 0.10,
    rootMargin: '0px 0px -10% 0px'
  };

  function cleanPath() {
    return window.location.pathname.replace(/\/$/, '');
  }

  function isHome() {
    var path = cleanPath();
    return (
      document.body.classList.contains('template-index') ||
      document.body.classList.contains('template--index') ||
      document.body.dataset.template === 'index' ||
      path === '' ||
      path === '/' ||
      path.split('/').filter(Boolean).length === 0
    );
  }

  function isProduct() {
    var path = cleanPath();
    return (
      document.body.classList.contains('template-product') ||
      document.body.classList.contains('template--product') ||
      document.body.dataset.template === 'product' ||
      path.indexOf('/products/') !== -1 ||
      path.indexOf('/producto/') !== -1
    );
  }

  function injectStyles() {
    if (document.getElementById('lumara-scroll-reveal-style')) return;

    var style = document.createElement('style');
    style.id = 'lumara-scroll-reveal-style';
    style.textContent = '\
      @media (prefers-reduced-motion: no-preference){\
        body.lumara-scroll-reveal-active #MainContent > .shopify-section.lumara-reveal-ready{\
          opacity:0;\
          transform:translateY(26px);\
          transition:opacity 780ms ease, transform 780ms cubic-bezier(.22,.8,.22,1);\
          will-change:opacity, transform;\
        }\
        body.lumara-scroll-reveal-active #MainContent > .shopify-section.lumara-reveal-ready.lumara-reveal-visible{\
          opacity:1;\
          transform:translateY(0);\
        }\
        body.lumara-scroll-reveal-active #MainContent > .shopify-section.lumara-reveal-ready:nth-child(2n){\
          transition-delay:60ms;\
        }\
        body.lumara-scroll-reveal-active #MainContent > .shopify-section.lumara-reveal-ready:nth-child(3n){\
          transition-delay:110ms;\
        }\
        @media screen and (max-width:749px){\
          body.lumara-scroll-reveal-active #MainContent > .shopify-section.lumara-reveal-ready{\
            transform:translateY(18px);\
            transition-duration:620ms;\
          }\
        }\
      }\
      @media (prefers-reduced-motion: reduce){\
        #MainContent > .shopify-section.lumara-reveal-ready{\
          opacity:1 !important;\
          transform:none !important;\
          transition:none !important;\
        }\
      }\
    ';
    document.head.appendChild(style);
  }

  function getMainSections() {
    var main = document.getElementById('MainContent');
    if (!main) return [];

    var directSections = Array.prototype.slice.call(main.children).filter(function (el) {
      return el.classList && el.classList.contains('shopify-section');
    });

    if (directSections.length) return directSections;

    return Array.prototype.slice.call(main.querySelectorAll('.shopify-section'));
  }

  function isProductInfoSection(section, index) {
    var idClass = ((section.id || '') + ' ' + (section.className || '')).toLowerCase();

    if (index === 0 && isProduct()) return true;

    return (
      idClass.indexOf('main-product') !== -1 ||
      section.querySelector('[id^="ProductInfo-"]') ||
      section.querySelector('.product__info-wrapper') ||
      section.querySelector('product-info') ||
      section.querySelector('.product-form') ||
      section.querySelector('.product__media-wrapper')
    );
  }

  function getRevealSections(sections) {
    if (isHome()) {
      return sections.filter(function (section, index) {
        if (index < CONFIG.homeExcludeFirstSections) {
          section.classList.add(CONFIG.visibleClass);
          return false;
        }
        return true;
      });
    }

    if (isProduct()) {
      return sections.filter(function (section, index) {
        if (isProductInfoSection(section, index)) {
          section.classList.add(CONFIG.visibleClass);
          return false;
        }
        return true;
      });
    }

    return [];
  }

  function reveal() {
    if (!isHome() && !isProduct()) return;

    document.body.classList.add('lumara-scroll-reveal-active');
    injectStyles();

    var sections = getMainSections();
    if (!sections.length) return;

    var revealSections = getRevealSections(sections);

    revealSections.forEach(function (section) {
      section.classList.add(CONFIG.readyClass);
    });

    if (!('IntersectionObserver' in window)) {
      revealSections.forEach(function (section) {
        section.classList.add(CONFIG.visibleClass);
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add(CONFIG.visibleClass);
        obs.unobserve(entry.target);
      });
    }, {
      threshold: CONFIG.threshold,
      rootMargin: CONFIG.rootMargin
    });

    revealSections.forEach(function (section) {
      if (section.classList.contains(CONFIG.observedClass)) return;
      section.classList.add(CONFIG.observedClass);
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(reveal, 80);
  });
})();
